import { type CitationFloatingToolbarState,FloatingCitationPageNumberInput,useFloatingCitationInsert, useFloatingCitationInsertState } from '@alpod-ai-writer/plate-plugins/citations/react';
import { cn } from '@udecode/cn';
import { useFormInputProps } from '@udecode/plate/react';
import {
    flip,
    offset,
    type UseVirtualFloatingOptions,
} from '@udecode/plate-floating';
import { BookTextIcon, SquareArrowOutUpRight } from 'lucide-react';

import { buttonVariants } from '../common/button.component';
import { inputVariants } from '../common/input.component';
import { popoverVariants } from '../common/popover.component';
import { Separator } from '../common/separator.component';

const floatingOptions: UseVirtualFloatingOptions = {
    middleware: [
        offset(12),
        flip({
            fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
            padding: 12,
        }),
    ],
    placement: 'bottom-start',
};

export interface CitationFloatingToolbarProps {
  state?: CitationFloatingToolbarState;
}

export function CitationFloatingToolbar({ state }: CitationFloatingToolbarProps) {
    const insertState = useFloatingCitationInsertState({
        ...state,
        floatingOptions: {
            ...floatingOptions,
            ...state?.floatingOptions,
        },
    });

    const {
        hidden,
        props: insertProps,
        ref: insertRef,
        editCallback,
        pageNumberPrefix
    } = useFloatingCitationInsert(insertState);

    const inputProps = useFormInputProps({
        preventDefaultOnEnterKeydown: true        
    });

    if (hidden) return null;

    const input = (
        <div className="flex w-[300px] flex-col" {...inputProps}>
            <div className="flex items-center gap-2">
                <div className="flex items-center pr-1 pl-2 text-gray-800">
                    <BookTextIcon className="size-4" />
                </div>
                <span>{pageNumberPrefix}</span>
                <FloatingCitationPageNumberInput
                    className={inputVariants({ h: 'sm', variant: 'ghost' })}
                    placeholder="č. stránky"
                    data-plate-focus
                />
                {editCallback && (
                    <>
                        <Separator orientation='vertical' className='h-4' />
                        <button
                            className={buttonVariants({ size: 'sm', variant: 'ghost' })}
                            type="button"
                            onClick={editCallback}
                        >
                            <SquareArrowOutUpRight width={18} />
                            Upravit citaci
                        </button>
                    </>
                )}
            </div>
        </div>
    );

    return (
        <>
            <div
                ref={insertRef}
                className={cn(popoverVariants(), 'w-auto p-1')}
                {...insertProps}
            >
                {input}
            </div>
        </>
    );
}
